var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('tree-view',{attrs:{"data":_vm.packJson,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }